const ko_KR = {
  restartInterviewButton: "처음부터 다시 시작",
  restartInterviewConfirmTitle: "새 인터뷰를 시작할까요?",
  restartInterviewConfirmDescription: "현재 진행 상황을 이어가지 않고 새 인터뷰를 처음부터 시작합니다. 기존 인터뷰 기록은 보관됩니다.",
  restartInterviewCancel: "취소",
  restartInterviewFailed: "인터뷰를 다시 시작하지 못했습니다. 잠시 후 다시 시도해 주세요.",
  restartInterviewLimitReached: "인터뷰 한도에 도달하여 새로 시작할 수 없습니다.",
  restartInterviewClosed: "인터뷰가 종료되어 새로 시작할 수 없습니다.",
  restartInterviewCutoff: "참여 마감 시간이 지나 새로 시작할 수 없습니다.",
  interviewLoading: "인터뷰를 불러오는 중…",
  interviewLinkInvalid: "유효하지 않은 인터뷰 링크입니다",
  interviewLoadFailed: "인터뷰를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
  interviewRetry: "다시 시도",
  saveInfoFailed: '정보를 저장하지 못했습니다. 다시 시도해 주세요.',
  loadLatestInterviewFailed: '최신 인터뷰 기록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  interviewProgressSaved: '인터뷰 진행 상황은 사라지지 않습니다',
  previousStimulus: '이전 콘셉트',
  nextStimulus: '다음 콘셉트',
  expandStimulus: '콘셉트 확대',
  closeStimulusPreview: '콘셉트 미리보기 닫기',
  stimulusPreview: '콘셉트 미리보기',
  imageTooLarge: '이미지 크기는 10 MB를 초과할 수 없습니다',
  imageFormatJpegPngOnly: 'PNG, JPEG, JPG 형식의 이미지만 지원합니다',
  imageFilesOnly: '이미지 파일만 업로드할 수 있습니다',
  imageUploadFailed: '이미지를 업로드하지 못했습니다. 다시 시도해 주세요.',
  finalUploadFailed: '파일을 업로드하지 못했습니다. 다시 시도해 주세요.',
  Welcome: '환영합니다',
  StartInterview: '인터뷰 시작',
  Submit: '제출',
  Stoprecording: '녹음 중지',
  Aiinterviewer: '인터뷰어',
  AiModeratedInterview: 'AI 진행 인터뷰',
  TalkToAva: 'Ava와 대화하기',
  microphoneAccessTitle: '마이크 접근 허용',
  microphoneAccessDescription: '자연스러운 음성 대화를 위해 Ava가 마이크를 사용합니다.',
  microphoneAllow: '마이크 허용',
  microphoneNotNow: '나중에',
  microphoneConnectedTitle: '마이크가 연결되었습니다',
  microphoneConnectedDescription: '준비되었습니다. Ava가 들을 준비를 마쳤습니다.',
  microphoneDeniedTitle: '마이크 권한이 필요합니다',
  microphoneDeniedDescription: '브라우저 설정에서 마이크 접근을 허용한 뒤 다시 시도하세요.',
  microphoneTryAgain: '다시 시도',
  VoiceAnswer: '음성 답변',
  TextAnswer: '텍스트 답변',
  StudyMainTitle: '실제 인터뷰 전에 사전 심사를 진행하겠습니다',
  StudyMainTip:
    '죄송합니다. 귀하는 이 인터뷰의 대상 그룹이 아니어서 참여하실 수 없습니다',
  // ThankYou: '감사합니다',
  //
  TitleTop: '대화에 참여해보세요',
  HeardVoice: '당신의 목소리를 들려주세요, 보상이 있습니다!',
  Sophie: 'Ava와 5-10분 간단한 대화를 나누세요',
  Sponsored: 'Sponsored by Santa Clause🎅',
  Chikkens: '빠른 대화를 시작하고 전용',
  Dollars: 'CHIMOJI 보상을 받으세요!',
  // Progress: 'the progress of this chat',
  Congrats: '축하합니다!',
  ThankYou: '귀중한 의견 감사합니다',

  Refresh: '페이지를 새로 고침해도 대화 진행 상황은 유지됩니다',
  Carousel: '인터넷 상태에 따라 약간의 지연이 발생할 수 있습니다',
  CheckOut: '이런 인터뷰를 만들고 싶으신가요? 확인해보세요 ',
  Rewarded: '보상을 받으시려면 면접관이 귀하의 정보를 알아야 합니다 ',
  InterviewerReward: '면접관이 드리는 보상입니다 ',
  Register: '로그인/가입하기',
  Insighteer: 'INSIGHTEER',
  Reward: '보상을 받으려면',
  CreatePassword: '비밀번호를 생성하여 등록을 완료하세요',
  Becoming: '우리의 일원이 되어보세요!',
  Password: '비밀번호를 입력해주세요!',
  ChooseTopic: '관심 있는 주제를 선택하세요',
  Identity: '당신은...',
  Awesome: 'Awesome!',
  Rocks: 'ROCKS',
  Followus: '팔로우하기',
  Unique: '이 독특한 CHIMOJI는 대화와 함께 블록체인에 NFT로 기록됩니다',
  Next: '다음',
  ViewRewards: '보상 확인하기',
  endMeg1: '음성 재생을 받으실 이메일을 남겨주세요',
  endMeg2: '이 인터뷰 제작자의 보상을 받으려면 여기에 정보를 남겨주세요',
  endMeg3: '이 인터뷰를 위해 여기에 정보를 남겨주세요',
  endMsg5: '귀하의 정보를 여기에 남겨주세요 ',
  endMsg6: 'MBTI 검사 결과',
  Done: '제출',
  Done1: '완료',
  GetIncentives: '보상 받기',
  GetStartedFreeNow: '지금 무료로 시작하기',
  UniqueChimojiNFT: '독특한 Chimoji NFT',
  endMsg4: '자신만의 인터뷰를 만들고 싶으신가요?',
  ResumeInterview: '클릭하여 인터뷰 계속하기',
  interviewPausedTitle: '인터뷰가 일시정지되었습니다',
  interviewPausedDescription: '진행 상황이 저장되었습니다. 준비되면 언제든지 계속할 수 있습니다.',
  resumeInterviewButton: '인터뷰 계속하기',
  pauseInterview: '일시정지',
  pauseInterviewConfirmTitle: '인터뷰를 일시정지할까요?',
  pauseInterviewConfirmContent: '진행 상황이 저장되며 나중에 인터뷰를 다시 시작할 수 있습니다.',
  pauseInterviewConfirmOk: '일시정지',
  pauseInterviewConfirmCancel: '인터뷰 계속하기',
  poorConnection: '연결 상태 불량',
  connectionReconnectingTitle: '다시 연결하는 중…',
  connectionReconnectingDescription: '이 페이지를 열어 두세요. Ava가 연결을 복구하고 있습니다.',
  connectionReconnectedTitle: '다시 연결되었습니다',
  connectionReconnectedDescription: '연결이 복구되었습니다. 인터뷰를 계속합니다.',
  connectionDisconnectedTitle: '연결이 끊어졌습니다',
  connectionDisconnectedDescription: '인터뷰 진행 상황이 저장되었습니다.',
  refresh: '페이지를 새로고침해도 진행 상황은 손실되지 않습니다.',
  voiceSnapshot: '음성 스냅샷',
  fromInterview: 'AI 스토리 큐레이터 Ava와의 인터뷰에서',
  findMore: 'Chikka.ai에서 더 알아보기',
  msg1: 'AVA와 대화하여 5분 만에 MBTI를 테스트하세요',
  speaking: '당신은 말하고 있습니다...',
  avaSpeaking: 'AVA는 말하고 있습니다...',
  avaListening: 'AVA는 듣고 있습니다...',
  stimuliConversationWithAva: 'Ava와 대화 중입니다',
  stimuliReviewConcepts:
    '아래의 콘셉트를 주의 깊게 살펴보고 Ava의 질문에 답해주세요.',
  stimuliSwipeInstruction:
    '모든 콘셉트를 보려면 왼쪽 또는 오른쪽으로 스와이프하세요.',
  stimuliFullscreenInstruction: '이미지를 두 번 클릭하면 전체 화면으로 볼 수 있습니다.',
  finalUploadTitleFallback: '파일 업로드',
  finalUploadInstructionFallback:
    '인터뷰를 마치기 전에 파일을 추가해주세요',
  finalUploadTap: '탭하여 업로드',
  finalUploadHelp:
    '파일은 귀하의 경험을 더 잘 이해하는 데 도움이 됩니다.',
  finalUploadLimit: '최대 10개 파일',
  finalUploadSubmit: '제출',
  finalUploadSkip: '건너뛰기',
  finalUploadWait: '모든 파일 업로드가 끝날 때까지 기다려주세요',
}
export default ko_KR
